<template>
  <div
    v-if="error && !result"
    class="tw-bg-red-50 tw-border tw-border-red-200 tw-rounded-lg tw-p-3 tw-text-sm tw-text-red-700"
  >
    Productietest mislukt: {{ error }}
  </div>
  <div v-else-if="running || result" class="tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-lg tw-p-3">
    <div v-if="running" class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-800">
      <span class="tw-w-4 tw-h-4 tw-border-2 tw-border-blue-200 tw-border-t-blue-600 tw-rounded-full tw-animate-spin tw-flex-shrink-0" />
      Productietest loopt via Cast4all, duurt ca. 3-4 minuten<span v-if="result?.status"> (status: {{ result.status }})</span>
    </div>

    <template v-if="result?.final">
      <div class="tw-flex tw-items-baseline tw-gap-2">
        <span class="tw-text-2xl tw-font-semibold tw-text-blue-900">
          {{ result.estimated_power_w != null ? `≈ ${formatDecimal(result.estimated_power_w, 0)} W` : '—' }}
        </span>
        <span
          class="tw-text-xs tw-font-medium tw-px-1.5 tw-py-0.5 tw-rounded"
          :class="result.status === 'Success' || result.status === 'End' ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-100 tw-text-red-700'"
        >{{ result.status }}<span v-if="result.result_message"> · {{ result.result_message }}</span></span>
      </div>
      <div class="tw-text-xs tw-text-blue-700">
        Gemiddelde productie tijdens de test
        <span v-if="result.exported_wh != null">({{ formatDecimal(result.exported_wh, 0) }} Wh in {{ durationLabel }})</span>
        · geen live waarde, schatting op hele Wh
      </div>
      <div class="tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-1 tw-mt-2 tw-text-sm tw-text-blue-900">
        <div>Spanning (gem. 10 min): {{ formatDecimal(result.average_voltage, 0) }} V</div>
        <div>Stroom: {{ formatDecimal(result.instantaneous_current, 2) }} A</div>
        <div v-if="result.instantaneous_power_export_w != null">Teruglevering op moment: {{ formatDecimal(result.instantaneous_power_export_w, 0) }} W</div>
        <div v-if="result.breaker_initial_status && result.breaker_initial_status !== 'N/A'">Breaker bij start: {{ result.breaker_initial_status }}</div>
        <div v-if="result.test_end_on" class="tw-text-blue-700">Afgerond: {{ formatDateTimeNL(result.test_end_on) }}</div>
      </div>
    </template>
    <div v-if="error && result" class="tw-text-xs tw-text-red-700 tw-mt-1">{{ error }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatDateTimeNL, formatDecimal } from './formatters'

const props = defineProps({
  running: { type: Boolean, default: false },
  result: { type: Object, default: null },
  error: { type: String, default: null },
})

const durationLabel = computed(() => {
  const { test_start_on: start, test_end_on: end } = props.result ?? {}
  if (!start || !end) return 'onbekende tijd'
  const seconds = Math.round((new Date(end) - new Date(start)) / 1000)
  return `${Math.floor(seconds / 60)}m${String(seconds % 60).padStart(2, '0')}s`
})
</script>
